import { useRef, useState, useEffect } from 'react'
import { useMediaQuery } from 'ui-component-library/components/MediaQuery'

function useSticky<T extends HTMLElement>(offset: number) {
  const stickyRef = useRef<T | null>(null)
  const [isSticky, setSticky] = useState(false)
  const [position, setPosition] = useState<number>()
  const { belowTablet } = useMediaQuery({ tablet: true })

  function handleScroll() {
    if (position && window.pageYOffset >= position - offset) {
      setSticky(true)
    } else {
      setSticky(false)
    }
  }

  useEffect(() => {
    if (position && !belowTablet) {
      window.addEventListener('scroll', handleScroll)
    }

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [position, belowTablet])

  useEffect(() => {
    if (stickyRef.current && stickyRef.current.offsetTop) {
      setPosition(stickyRef.current.offsetTop)
    }
  }, [stickyRef])

  return {
    stickyRef,
    isSticky: !belowTablet && isSticky,
  }
}

export default useSticky
